// ============================================================================
// Hooks TanStack Query — ADMINISTRATION (vague Admin, AD-A) : bundle onglet Audit
// ============================================================================
// Hook = TanStack Query SEULEMENT (regle parc). L'autorisation vit au SERVEUR
// (P-ADM-2, routes/admin.ts : garde `canAccessGestAdmin` = role === 'admin'
// SEUL, director/manager/employee REFUSES). Le SPA consomme le bundle assemble ;
// il ne DECIDE jamais (lecon GA-05). Un 403 serveur devient une redirection
// /error/403 (AdminPage), pas un crash.
//
// AD-A : une seule query (GET /audit — la plus simple, lecture pure) qui sert
// AUSSI de garde client au shell (montee quel que soit l'onglet actif). Les
// bundles par onglet (overview/members/teams/remuneration/contrats/questions)
// arrivent en serie AD-B..AD-F sous la MEME racine ADMIN_ROOT_KEY (une ecriture
// admin invalidera la famille entiere d'un coup, pattern GRILLE_CE_ROOT_KEY).

import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';

// ─── Types — MIROIR EXACT du DTO serveur (routes/admin.ts GET /audit) ─────────

/** Role Admin (etage 3). Le DTO ne sort admin qu'apres la garde (director => 403). */
export type GestAdminRole = 'admin' | 'manager' | 'director' | 'employee';

/**
 * Evenement d'audit (miroir AuditEventDTO serveur). `action`/`targetType` sont
 * des string libres : le journal affiche aussi les actions historiques
 * d'anciennes versions de l'union (le libelle retombe sur l'action brute).
 */
export interface AdminAuditEvent {
  id: string;
  action: string;
  actorEmail: string;
  targetType: string;
  targetId: string;
  /** metadata_json parse serveur (champs surs seulement — jamais de PII brute). */
  metadata: Record<string, string> | null;
  createdAt: string;
}

/** Bundle de l'onglet AUDIT (P-ADM-10) — miroir de la reponse GET /audit. */
export interface AdminAuditResponse {
  viewer: { role: GestAdminRole; email: string };
  /** Les 100 derniers evenements (append-only D7, tries created_at DESC serveur). */
  events: AdminAuditEvent[];
}

// ─── Query (bundle onglet AUDIT + garde client du shell) ──────────────────────

/** Racine des queries ADMIN — les bundles AD-B..AD-F s'enregistrent dessous. */
export const ADMIN_ROOT_KEY = ['gest', 'admin'] as const;
const adminAuditKey = [...ADMIN_ROOT_KEY, 'audit'] as const;

/**
 * P-ADM-10 : bundle de l'onglet AUDIT (1 requete SPA). 403 (non-admin) = etat
 * stable (pas de retry) : AdminPage redirige vers /error/403 (garde client
 * P-ADM-2, double la garde serveur — GA-05).
 */
export function useAdminAudit(enabled: boolean) {
  return useQuery({
    queryKey: adminAuditKey,
    queryFn: () => api.get<AdminAuditResponse>('/api/admin/audit'),
    enabled,
    retry: false,
  });
}
